import {Base64} from 'js-base64';

import {ObjectUtils} from '../../Utils/ObjectUtils';
import {config} from '../../Config';
import {SET_PERMISSIONS, SET_USER, SET_NOTIFICATIONS} from "../../Redux/Actions/Types";

let auth_token = '';
let token_data = {};
let permissions = [];
let notifications = [];

function setTokenData() {
    let new_token_data, userChannelPayload;
    if(auth_token && auth_token != '') {
        new_token_data = JSON.parse(Base64.decode(auth_token.split('.')[1]));
        userChannelPayload = new_token_data;
    } else {
        new_token_data = {};
        userChannelPayload = null;
    }

    if(!ObjectUtils.Compare(token_data, new_token_data)) {
        token_data = new_token_data;
        config.getStore().dispatch({
            type: SET_USER,
            user: userChannelPayload,
        });
    }
}

function setPermissionsState() {
    config.getStore().dispatch({
        type: SET_PERMISSIONS,
        permissions,
    });
}

function setNotificationsState() {
    config.getStore().dispatch({
        type: SET_NOTIFICATIONS,
        notifications,
    });
}

export function initializeBaseServiceState() {
    if (localStorage.getItem("storedAuthToken") != null) {
        auth_token = localStorage.getItem("storedAuthToken");
        setTokenData();
    }

    if (localStorage.getItem("storedPermissions") != null) {
        let savedData = localStorage.getItem("storedPermissions");
        permissions = JSON.parse(savedData);
        setPermissionsState();
    }

    if (localStorage.getItem("storedNotifications") != null) {
        let savedData = localStorage.getItem("storedNotifications");
        notifications = JSON.parse(savedData);
        setNotificationsState();
    }

    window.addEventListener('storage', (e) => {
        if(e.key == "storedAuthToken") {
            if(auth_token != e.newValue) {
                auth_token = e.newValue;
                setTokenData();
            }
        } else if (e.key == "storedPermissions") {
            let savedData = e.newValue;
            let parsedData = JSON.parse(savedData);

            if(!ObjectUtils.Compare(parsedData, permissions)) {
                permissions = parsedData;
                setPermissionsState();
            }
        }
    });
}

export function getAuthToken() {
    return auth_token;
}

export function setAuthToken(value) {
    auth_token = value ?? '';
    setTokenData();
}

export function getTokenData() {
    return token_data;
}

export function getPermissions() {
    return permissions;
}

export function setPermissionsValue(value) {
    permissions = value ?? [];
    setPermissionsState();
}

export function getNotifications() {
    return notifications;
}

export function setNotificationsValue(value) {
    notifications = value ?? [];
    setNotificationsState();
}

export function applyAuthResponsePayload(result) {
    if(result?.jwt) {
        setAuthToken(result.jwt);
        localStorage.setItem("storedAuthToken", result.jwt);

        if(result.permissions) {
            setPermissionsValue(result.permissions);
            localStorage.setItem("storedPermissions", JSON.stringify(result.permissions));
        }

        if(result.notifications) {
            setNotificationsValue(result.notifications);
            localStorage.setItem("storedNotifications", JSON.stringify(result.notifications));
        }
    }
}

export function isTwoFactorRequired() {
    return token_data?.twoFactorRequired;
}
